export const UnMaskFormat = (value: any) => {
  const unMaskFormat = value
    .toString()
    .replace('R$', '')
    .replace('.', '')
    .replace(',', '.')
    .replace(' ', '');

  return unMaskFormat;
};
